@mixin text-lg {
    font-size: var(--text-lg, 18px);
}

@mixin text-normal {
    font-size: var(--text-normal, 16px);
    line-height: normal;
}

.underline {
    text-decoration: underline;
}

.text-normal {
    @include text-normal
}

.text-lg {
    @include text-lg;
}

.text-slate {
    color: var(--mdc-theme-slate, var(--wf-gray-04, #e5dfdf));
}

.text-accent {
    color: var(--mdc-theme-accent, #ea5659);
}

a.text-black {
    color: #000;

    &:hover {
        color: var(--mdc-theme-accent, #ea5659);
    }
}

.p-2 {
    padding: 8px 16px;
}

.pt-2 {
    padding: 8px 0;
}

.mr-1 {
    margin-right: 4px;
}

.hidden {
    display: none;
}

:host {
    box-sizing: border-box;

    --vx-circular-progress-color: var(--mdc-theme-primary);

    padding: 0 0 16px;
    font-size: 16px;

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    li {
        @include text-lg;
        text-decoration: none;
        color: currentcolor;
        display: flex;
        flex-flow: column;
        align-content: center;
        gap: 8px;
        padding: 16px;

        &.icon-link {
            padding: 0;

            a {
                text-decoration: none;
                color: currentcolor;
                padding: 16px;
                display: flex;
                flex-flow: row;
                align-content: center;
                gap: 8px;

                img {
                    height: 20px;
                    width: 20px;
                }

                &:hover {
                    color: var(--mdc-theme-accent, #ea5659);

                    img {
                        filter: invert(54%) sepia(30%) saturate(7423%) hue-rotate(326deg) brightness(97%) contrast(89%);
                    }
                }
            }
        }

        &:not(:last-child, .form-container, .menu-logged-in, .menu-logged-out) {
            border-bottom: 1px solid var(--border-color, var(--mdc-border-color, #e5dfdf));
        }
    }

    form {
        position: relative;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .error-message {
            font-weight: 100;
            color: var(--text-danger, #ea5659);
        }

        input {
            width: 100%;
            box-sizing: border-box;
            line-height: 22px;
            padding: 16px;
            outline: none;
            border: 1px solid var(--border-color, var(--mdc-border-color, #e5dfdf));
            font-size: inherit;
            font-weight: inherit;
            font-family: inherit;
            font-stretch: inherit;
            color: currentcolor;
            border-radius: var(--mdc-shape-small, 2px);

            &.has-error {
                border-color: red;
            }
        }

        .loading-overlay {
            display: flex;
            position: absolute;
            left: 0;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: calc(100% - 32px);
            background-color: rgb(255 255 255 / 60%);
            opacity: 0;
            z-index: -1;

        }

        &.is--loading {
            .loading-overlay {
                opacity: 1;
                z-index: 0;
            }
        }
    }
}


